// ./client/src/types/courseDomains.js

export const CourseDomains = {

    IoT: {
        canvasLayout: 'horizontal',
        simulationMode: 'realtime',
        outputType: 'schematic',
        polling: {
            baseInterval:    2500,
            loopDelayBuffer: 500,
            cap:             21,
        },
        snapshotShape: {
            timestamp:      null,
            sensors:        {},
            actuatorStates: {},
        },
        runtimeFields: [
            { field: 'serialOutput',          default: [] },
            { field: 'serialInput',           default: [] },
            { field: 'simulationSnapshots',   default: [] },
            { field: 'codeValidationResults', default: [] },
        ],
        gradingPayloadFields: {
            serialOutput:             [],
            serialInput:              [],
            uploadedCode:             '',
            actuatorStates:           {},
            attachedSensors:          [],
            attachedActuators:        [],
            attachedDisplays:         [],
            simulationSnapshots:      [],
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key: 'hardware',
                refKey: 'canvasRef1',
                header: 'Device Layer',
                subHeader: 'Physical Devices',
                icon: '🔧',
                output: 'schematic',
                emptyMessage: '🎨 Drag hardware components here',
                backgroundColor: '#ffffff',
                categories: [
                    { key: 'boards',           label: '🔷 Boards' },
                    { key: 'sensors',          label: '🌡️ Sensors' },
                    { key: 'actuators',        label: '⚡ Actuators' },
                    { key: 'displays',         label: '🖥️ Displays' },
                    { key: 'modules',          label: '🔌 Modules' },
                    { key: 'power',            label: '🔋 DC Power Supplies' },
                    { key: 'components',       label: '🔧 Components' },
                    { key: 'security_device',  label: '🔐 Security Device' },
                    { key: 'plc',              label: '🏭 PLCs & Field Devices' },
                ],
            },
            {
                key: 'bridge',
                refKey: 'canvasRef3',
                header: 'Network Layer',
                icon: '📡',
                emptyMessage: '📡 Drag communication protocols here',
                backgroundColor: '#fffbeb',
                categories: [
                    { key: 'communication',  label: '🤝 Communication Protocols' },
                    { key: 'edge_computing', label: '🕸️ Edge Computing' },
                ],
            },
            {
                key: 'cloud',
                refKey: 'canvasRef2',
                header: 'Cloud Layer',
                subHeader: 'Azure Services',
                icon: '☁️',
                emptyMessage: '☁️ Drag cloud services here',
                backgroundColor: '#f0f7ff',
                categories: [
                    { key: 'azure_iot',           label: '☁️ Azure IoT' },
                    { key: 'azure_analytics',     label: '📊 Azure Analytics' },
                    { key: 'azure_storage',       label: '💾 Azure Storage' },
                    { key: 'azure_visualization', label: '📈 Azure Visualization' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:      '📡 Protocols',
            pinTabLabel:           '🔌 Software Pins',
            showWireless:          true,
            protocolSectionTitle:  'Communication Protocols',
            pinSectionTitle:       'Software Pin Configuration',
            emptyProtocolMessage:  'No communication protocols available',
            emptyPinMessage:       'This component does not have software pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections' },
                { key: 'protocols',     label: 'Protocols' },
                { key: 'i2cAddresses',  label: 'I2C Conflicts' },
                { key: 'dependencies',  label: 'Dependencies' },
                { key: 'configuration', label: 'Configuration' },
            ],
            successMessages: [
                '✅ All power connections: OK',
                '✅ All ground connections: OK',
                '✅ No floating pins detected',
                '✅ Circuit is ready to sync!',
            ],
        },
        wireTypes: [
            { value: 'power',  label: '⚡ Power' },
            { value: 'ground', label: '⏚ Ground' },
            { value: 'signal', label: '📡 Signal' },
            { value: 'data',   label: '💾 Data (I2C/SPI)' },
        ],
        reportTitle:   '📡 IoT Lab Report',
        gradingTitle:  '📡 Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview' },
            { id: 'snapshots',          label: '📸 Snapshots' },
            { id: 'serial',             label: '🖥️ Serial Monitor' },
            { id: 'code',               label: '💻 Code' },
            { id: 'code-validation',    label: '🔍 Code Validation' },
            { id: 'circuit-validation', label: '🔌 Circuit Validation' },
        ],
        configureButtonTooltip: 'Configure Protocols, Wireless & Software Pins',
        buttonTitle:            '🔧 My IoT Circuits',
        simulator:              'simulator',
        simulatorLabel:         '▶️ 3. Simulate',
        simulatorIcon:          '🖥️ ',
        simulatorButtonLabel:   'Open Simulator',
        simulatorTooltip:       'Open Simulator',
    },

    IIoT: {
        canvasLayout: 'horizontal',
        simulationMode: 'realtime',
        outputType: 'schematic',
        polling: {
            baseInterval: 1000,
            cap:          20,
        },
        snapshotShape: {
            timestamp:      null,
            sensorText:     {},
            actuatorStates: {},
            plcToGateway: {
                protocol:  '',
                formatted: '',
            },
            gatewayToAzure: {
                protocol:  '',
                formatted: '',
            },
            azureDecoded: {},
            nodeLastData: {},
        },
        runtimeFields: [
            { field: 'simulationSnapshots',   default: [] },
            { field: 'codeValidationResults', default: [] },
        ],
        // Must match server/types/CourseDomains.ts IIoT.gradingPayloadFields exactly.
        // Used by simulationReport.jsx to extract evidenceData from gradingResult.
        gradingPayloadFields: {
            flowNodes:                [],
            flowWires:                [],
            flowStats:                {},
            gatewayConfig:            {},
            simulationSnapshots:      [],
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key: 'hardware',
                refKey: 'canvasRef1',
                header: 'Device Layer',
                subHeader: 'Physical Devices',
                icon: '🔧',
                output: 'schematic',
                output: 'none',
                emptyMessage: '🎨 Drag hardware components here',
                backgroundColor: '#ffffff',
                categories: [
                    { key: 'boards',           label: '🔷 Boards' },
                    { key: 'sensors',          label: '🌡️ Sensors' },
                    { key: 'actuators',        label: '⚡ Actuators' },
                    { key: 'displays',         label: '🖥️ Displays' },
                    { key: 'modules',          label: '🔌 Modules' },
                    { key: 'power',            label: '🔋 DC Power Supplies' },
                    { key: 'components',       label: '🔧 Components' },
                    { key: 'security_device',  label: '🔐 Security Device' },
                    { key: 'plc',              label: '🏭 PLCs & Field Devices' },
                ],
            },
            {
                key: 'bridge',
                refKey: 'canvasRef3',
                header: 'Network Layer',
                icon: '📡',
                emptyMessage: '📡 Drag communication protocols here',
                backgroundColor: '#fffbeb',
                categories: [
                    { key: 'communication',  label: '🤝 Communication Protocols' },
                    { key: 'edge_computing', label: '🕸️ Edge Computing' },
                ],
            },
            {
                key: 'cloud',
                refKey: 'canvasRef2',
                header: 'Cloud Layer',
                subHeader: 'Azure Services',
                icon: '☁️',
                emptyMessage: '☁️ Drag cloud services here',
                backgroundColor: '#f0f7ff',
                categories: [
                    { key: 'azure_iot',           label: '☁️ Azure IoT' },
                    { key: 'azure_analytics',     label: '📊 Azure Analytics' },
                    { key: 'azure_storage',       label: '💾 Azure Storage' },
                    { key: 'azure_visualization', label: '📈 Azure Visualization' },
                ],
            },
        ],
        nodeRedSubCanvas: {
            domain:        'NodeRed',
            sessionKey:    'flowSessionId',
            sessionPrefix: 'SESSION_NR',
            flowField:     'nodeRedFlow',
            modalTitle:    '🔴 Node-RED Flow Editor',
            description:   'Open the flow canvas in a new tab to drag and drop Node-RED nodes and build your IIoT data pipeline.',
            openLabel:     '🔴 Open Flow Canvas',
            accentColor:   '#8F0000',
            urlParam:      'gatewayInstanceId',
        },
        fbdSubCanvas: {
            domain:        'FBD',
            sessionKey:    'fbdSessionId',
            sessionPrefix: 'SESSION_FBD',
            flowField:     'plcFlow',
            modalTitle:    '🏭 FBD Program Editor',
            description:   'Open the FBD canvas in a new tab to drag and drop function blocks and build your PLC control program.',
            openLabel:     '🏭 Open FBD Canvas',
            accentColor:   '#009999',
            urlParam:      'plcInstanceId',
        },
        configModal: {
            protocolTabLabel:     '⚙️ Node Configuration',
            pinTabLabel:          '🔌 Port Settings',
            showWireless:         false,
            protocolSectionTitle: 'Node Configuration',
            pinSectionTitle:      'Port Configuration',
            emptyProtocolMessage: 'No configuration available for this node',
            emptyPinMessage:      'This node does not have configurable ports',
        },
        validation: {
            filters: [
                { key: 'connections',    label: 'Connections' },
                { key: 'protocols',      label: 'Protocols' },
                { key: 'i2cAddresses',   label: 'I2C Conflicts' },
                { key: 'configuration',  label: 'Configuration' },
                { key: 'flow_integrity', label: 'Flow Integrity' },
                { key: 'dependencies',   label: 'Dependencies' },
            ],
            successMessages: [
                '✅ All nodes connected: OK',
                '✅ All nodes configured: OK',
                '✅ Flow has valid input → output path',
                '✅ Flow is ready to deploy!',
            ],
        },
        wireTypes: [
            { value: 'nr_message', label: '📨 Message Wire' },
        ],
        reportTitle:  '🧠 IIoT Lab Report',
        gradingTitle: '🧠 IIoT Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview' },
            { id: 'snapshots',          label: '📸 Snapshots' },
            { id: 'dashboard',          label: '📓 Dashboard' },
            { id: 'code-validation',    label: '🔍 Code Validation' },
            { id: 'circuit-validation', label: '🧠 Pipeline Validation' },
        ],
        configureButtonTooltip: 'Configure Node & Port Settings',
        buttonTitle:            '🔴 My Node-RED Flows',
        simulator:              'node-red-dashboard',
        simulatorLabel:         '▶️ 3. Open Dashboard',
        simulatorIcon:          '🔴 ',
        simulatorButtonLabel:   'Open Dashboard',
        simulatorTooltip:       'Open Node-RED Dashboard',
    },

    NodeRed: {
        canvasLayout: 'vertical',
        subCanvasLoader: 'flow', 
        outputType: 'config',
        // Sub-canvas only — no simulationMode, no polling, no snapshotShape,
        // no runtimeFields. Never reaches a simulator page.
        canvases: [
            {
                key: 'flow',
                refKey: 'canvasRef1',
                header: 'Flow Canvas',
                subHeader: 'Node-RED Data Pipeline',
                icon: '🔴',
                output: 'config',
                emptyMessage: '🔴 Drag Node-RED nodes here to build your flow',
                backgroundColor: '#fff8f0',
                categories: [
                    { key: 'nr_input',      label: '📥 Input Nodes' },
                    { key: 'nr_processing', label: '⚙️ Processing Nodes' },
                    { key: 'nr_output',     label: '📤 Output Nodes' },
                    { key: 'nr_storage',    label: '💾 Storage Nodes' },
                    { key: 'nr_dashboard',  label: '🖥️ UI Nodes' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:     '⚙️ Node Configuration',
            pinTabLabel:          '🔌 Port Settings',
            showWireless:         false,
            protocolSectionTitle: 'Node Configuration',
            pinSectionTitle:      'Port Configuration',
            emptyProtocolMessage: 'No configuration available for this node',
            emptyPinMessage:      'This node does not have configurable ports',
        },
        validation: {
            filters: [
                { key: 'connections',    label: 'Connections' },
                { key: 'protocols',      label: 'Protocols' },
                { key: 'i2cAddresses',   label: 'I2C Conflicts' },
                { key: 'configuration',  label: 'Configuration' },
                { key: 'flow_integrity', label: 'Flow Integrity' },
                { key: 'dependencies',   label: 'Dependencies' },
            ],
            successMessages: [
                '✅ All nodes connected: OK',
                '✅ All nodes configured: OK',
                '✅ Flow has valid input → output path',
                '✅ Flow is ready to deploy!',
            ],
        },
        wireTypes: [
            { value: 'nr_message', label: '📨 Message Wire' },
        ],
        configureButtonTooltip: 'Configure Node & Port Settings',
        buttonTitle:            '🔴 My Node-RED Flows',
    },

    FBD: {
        canvasLayout: 'vertical',
        subCanvasLoader: 'fbd',
        outputType: 'config',
        // Sub-canvas only — no simulationMode, no polling, no snapshotShape.
        canvases: [
            {
                key: 'fbd',
                refKey: 'canvasRef1',
                header: 'FBD Canvas',
                subHeader: 'Function Block Diagram',
                icon: '🏭',
                output: 'config',
                emptyMessage: '🏭 Drag FBD blocks here to build your PLC program',
                backgroundColor: '#f0fdf4',
                categories: [
                    { key: 'fbd_input',  label: '📥 Input Modules' },
                    { key: 'fbd_output', label: '📤 Output Modules' },
                    { key: 'fbd_logic',  label: '⚖️ Logic Blocks' },
                    { key: 'fbd_math',   label: '➗ Math & PID' },
                    { key: 'fbd_timer',  label: '⏱️ Timers & Counters' },
                    { key: 'fbd_comm',   label: '📡 Communication Out' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:     '⚙️ Block Configuration',
            pinTabLabel:          '🔌 Port Settings',
            showWireless:         false,
            protocolSectionTitle: 'Function Block Configuration',
            pinSectionTitle:      'Port Configuration',
            emptyProtocolMessage: 'No configuration available for this block',
            emptyPinMessage:      'This block has no configurable ports',
        },
        validation: {
            filters: [
                { key: 'connections',    label: 'Connections' },
                { key: 'configuration',  label: 'Configuration' },
                { key: 'flow_integrity', label: 'Flow Integrity' },
            ],
            successMessages: [
                '✅ All blocks connected: OK',
                '✅ All blocks configured: OK',
                '✅ FBD has valid input → comm output path',
                '✅ FBD program is ready!',
            ],
        },
        wireTypes: [
            { value: 'fbd_real', label: '🟠 REAL Wire' },
            { value: 'fbd_bool', label: '🟣 BOOL Wire' },
        ],
        configureButtonTooltip: 'Configure Function Block',
        buttonTitle: '🏭 My FBD Programs',
    },

    AI: {
        canvasLayout: 'vertical',
        simulationMode: 'local',
        executionContext: 'pyodide',
        outputType: 'config',
        // no polling, no snapshotShape — runs in Pyodide locally
        runtimeFields: [
            { field: 'codeValidationResults', default: [] },
        ],
        gradingPayloadFields: {
            cellOutputs:              [],
            cellsExecuted:            0,
            totalCells:               0,
            hasErrors:                false,
            stdoutSummary:            '',
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key: 'training',
                refKey: 'canvasRef1',
                header: 'Training Canvas',
                subHeader: 'AI Training Workflow',
                icon: '🧠',
                output: 'config',
                output: 'microchip-code',
                emptyMessage: '🧠 Drag training nodes here',
                backgroundColor: '#f5f3ff',
                categories: [
                    { key: 'data',          label: '📄 Data' },
                    { key: 'preprocessing', label: '🔀 Preprocessing' },
                    { key: 'model',         label: '🧠 Model' },
                    { key: 'training',      label: '🔄 Training' },
                ],
            },
            {
                key: 'test',
                refKey: 'canvasRef2',
                header: 'Test Canvas',
                subHeader: 'AI Test Workflow',
                icon: '🧪',
                emptyMessage: '🧪 Drag evaluation nodes here',
                backgroundColor: '#f0fdf4',
                categories: [
                    { key: 'evaluation', label: '🎯 Evaluation' },
                    { key: 'aiOutput',     label: '🖨️ Output' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:     '⚙️ Configuration',
            pinTabLabel:          '🔗 Data Pins',
            showWireless:         false,
            protocolSectionTitle: 'Component Configuration',
            pinSectionTitle:      'Data Pin Configuration',
            emptyProtocolMessage: 'No configuration available',
            emptyPinMessage:      'This component does not have data pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections' },
                { key: 'pipeline',      label: 'Pipeline Order' },
                { key: 'configuration', label: 'Configuration' },
            ],
            successMessages: [
                '✅ Pipeline connections: OK',
                '✅ All stages configured: OK',
                '✅ No missing pipeline stages',
                '✅ Pipeline is ready to run!',
            ],
        },
        wireTypes: [
            { value: 'ai_data',    label: '🔗 Data Flow' },
            { value: 'model_data', label: '🧠 Model Data' },
            { value: 'evaluation', label: '🎯 Evaluation' },
            { value: 'output',     label: '🖨️ Output' },
        ],
        reportTitle:  '🧠 AI Lab Report',
        gradingTitle: '🧠 AI Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview' },
            { id: 'notebook',           label: '📓 Notebook' },
            { id: 'code-validation',    label: '🔍 Code Validation' },
            { id: 'circuit-validation', label: '🧠 Pipeline Validation' },
        ],
        cellCategoryTags: {
            data:          { bg: '#E6F1FB', color: '#185FA5', label: 'data' },
            preprocessing: { bg: '#E1F5EE', color: '#0F6E56', label: 'preprocess' },
            model:         { bg: '#EEEDFE', color: '#534AB7', label: 'model' },
            training:      { bg: '#FAECE7', color: '#993C1D', label: 'train' },
            evaluation:    { bg: '#FAEEDA', color: '#854F0B', label: 'eval' },
            output:        { bg: '#EAF3DE', color: '#3B6D11', label: 'output' },
        },
        configureButtonTooltip: 'Configure Component & Data Pins',
        notebookTitle:          '🧠 AI Notebook',
        buttonTitle:            '🧠 My AI Pipelines',
        fileUploadComponentIds: ['AI_DATA_CSV', 'AI_DATA_IMAGES'],
        imageComponentIds:      ['AI_DATA_IMAGES'],
        simulator:              'notebook',
        simulatorLabel:         '▶️ 3. Run Notebook',
        simulatorIcon:          '📓 ',
        simulatorButtonLabel:   'Open Notebook',
        simulatorTooltip:       'Open AI Notebook',
    },

    AgenticAI: {
        canvasLayout: 'vertical',
        simulationMode: 'local',
        executionContext: 'nodejs',
        outputType: 'config',
        // No polling, no snapshotShape.
        // Cells display Python code (industry standard) but execute via JavaScript
        // in the browser through the Node.js backend proxy — which injects OpenAI
        // and Pinecone API keys server-side. Students never see or handle keys.
        // Each cell stores both pythonCode (displayed) and javascriptCode (executed).
        runtimeFields: [
            { field: 'codeValidationResults', default: [] },
            {
                field:   'notebookCells',
                resetFn: (cells) => cells.forEach((c) => {
                    c.simOutputs     = {};
                    c.executionCount = 0;
                }),
            },
        ],
        // Must mirror server/types/CourseDomains.ts AgenticAI.gradingPayloadFields exactly.
        gradingPayloadFields: {
            cellOutputs:              [],
            cellsExecuted:            0,
            totalCells:               0,
            hasErrors:                false,
            stdoutSummary:            '',
            agentNodesExecuted:       [],
            graphCompiled:            false,
            ragRetrieved:             false,
            memoryTiersUsed:          [],
            toolCallsMade:            0,
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key:             'build',
                refKey: 'canvasRef1',
                header:          'Build Canvas',
                subHeader:       'Agentic System Design',
                icon:            '🤖',
                output: 'config',
                output:          'microchip-code',
                emptyMessage:    '🤖 Drag agentic AI components here',
                backgroundColor: '#f5f3ff',
                categories: [
                    { key: 'foundation', label: '🧱 Foundation'  },
                    { key: 'chain',      label: '🔗 LangChain'   },
                    { key: 'rag',        label: '📚 RAG Pipeline' },
                    // NOTE: 'graph' has NO hasSubCanvas/subCanvasKey here.
                    // The LangGraph sub-canvas is opened by the AG_GRAPH_BUILDER
                    // component (isFlowEngine: true) — same pattern as IIoT gateway
                    // opening NodeRed. This is consistent with the existing architecture.
                    { key: 'graph',      label: '🕸️ LangGraph'   },
                    { key: 'mcp',      label: '🔗 MCP'   },
                    { key: 'tools',  label: '🛠️ Tools'  },
                    { key: 'memory', label: '🧠 Memory'  },
                    { key: 'agenticOutput', label: '🖨️ Output'  },
                    { key: 'api', label: '🔌 API'  },
                ],
            },
        ],
        langGraphSubCanvas: {
            domain:        'LangGraph',
            sessionKey:    'graphSessionId',
            sessionPrefix: 'SESSION_GRAPH',
            flowField:     'graphFlow',
            modalTitle:    '🕸️ LangGraph Graph Builder',
            description:   'Open the Graph Canvas in a new tab to drag and drop LangGraph nodes, wire edges, and define conditional routing for your agentic AI system.',
            openLabel:     '🕸️ Open Graph Canvas',
            accentColor:   '#7C3AED',
            urlParam:      'graphInstanceId',
        },
        configModal: {
            protocolTabLabel:     '⚙️ Configuration',
            pinTabLabel:          '🔗 Data Pins',
            showWireless:         false,
            protocolSectionTitle: 'Component Configuration',
            pinSectionTitle:      'Data Pin Configuration',
            emptyProtocolMessage: 'No configuration available',
            emptyPinMessage:      'This component does not have data pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections'   },
                { key: 'pipeline',      label: 'Pipeline Order' },
                { key: 'configuration', label: 'Configuration'  },
                { key: 'graph',         label: 'Graph Wiring'   },
            ],
            successMessages: [
                '✅ Pipeline connections: OK',
                '✅ All components configured: OK',
                '✅ Graph nodes and edges: OK',
                '✅ Agentic pipeline ready to run!',
            ],
        },
        wireTypes: [
            { value: 'agent_data',  label: '🔗 Agent Data Flow' },
            { value: 'state_flow',  label: '🕸️ State Flow'      },
            { value: 'rag_context', label: '📚 RAG Context'     },
            { value: 'tool_call',   label: '🛠️ Tool Call'       },
            { value: 'memory_flow', label: '🧠 Memory Flow'     },
        ],
        reportTitle:  '🤖 Agentic AI Lab Report',
        gradingTitle: '🤖 Agentic AI Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview'           },
            { id: 'notebook',           label: '📓 Notebook'           },
            { id: 'code-validation',    label: '🔍 Code Validation'    },
            { id: 'circuit-validation', label: '🕸️ Pipeline Validation' },
        ],
        cellCategoryTags: {
            foundation:  { bg: '#E6F1FB', color: '#185FA5', label: 'foundation' },
            chain:       { bg: '#EEEDFE', color: '#534AB7', label: 'chain' },
            rag:         { bg: '#E1F5EE', color: '#0F6E56', label: 'rag' },
            graph:       { bg: '#FDF4FF', color: '#7C3AED', label: 'graph' },
            graph_nodes: { bg: '#FDF4FF', color: '#7C3AED', label: 'node' },
            graph_edges: { bg: '#FDF4FF', color: '#8E44AD', label: 'edge' },
            tools:       { bg: '#FAECE7', color: '#993C1D', label: 'tools' },
        },
        configureButtonTooltip: 'Configure Component & Data Pins',
        notebookTitle:          '🤖 Agentic AI Notebook',
        buttonTitle:            '🤖 My Agentic Pipelines',
        simulator:              'notebook',
        simulatorLabel:         '▶️ 3. Run Notebook',
        simulatorIcon:          '📓 ',
        simulatorButtonLabel:   'Open Notebook',
        simulatorTooltip:       'Open Agentic AI Notebook',
    },

    LangGraph: {
        canvasLayout: 'vertical',
        subCanvasLoader: 'graph',
        outputType: 'config',
        // Sub-canvas only — no simulationMode, no polling, no snapshotShape,
        // no runtimeFields. Never reaches a simulator page.
        canvases: [
            {
                key:             'graph',
                refKey:          'canvasRef1',
                header:          'Graph Canvas',
                subHeader:       'LangGraph Node Wiring',
                icon:            '🕸️',
                output:          'config',
                emptyMessage:    '🕸️ Drag graph nodes and edges here to wire your agent',
                backgroundColor: '#fdf4ff',
                categories: [
                    { key: 'foundation', label: '🤖 LLM Foundation' },
                    { key: 'chain', label: '🔗 LangChain' },
                    { key: 'graph', label: '🕸️ LangGraph'    },
                    { key: 'graph_nodes', label: '📦 Graph Nodes'    },
                    { key: 'graph_edges', label: '↔️ Graph Edges' },
                    { key: 'tools', label: '🧩 Tools' },
                    { key: 'rag', label: '🔎 RAG' },
                    { key: 'memory', label: '🧠 Memory' },
                    { key: 'api', label: '📡 API' },
                    { key: 'agenticOutput', label: '📤 Agentic Output' },
                    { key: 'mcp', label: '🔌 MCP' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:     '⚙️ Configuration',
            pinTabLabel:          '🔗 Data Pins',
            showWireless:         false,
            protocolSectionTitle: 'Node Configuration',
            pinSectionTitle:      'State Pin Configuration',
            emptyProtocolMessage: 'No configuration available for this node',
            emptyPinMessage:      'This node does not have state pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections'  },
                { key: 'graph',         label: 'Graph Wiring' },
                { key: 'configuration', label: 'Configuration' },
            ],
            successMessages: [
                '✅ Graph node connections: OK',
                '✅ All nodes configured: OK',
                '✅ Conditional edges have valid branches: OK',
                '✅ Graph is ready to compile!',
            ],
        },
        wireTypes: [
            { value: 'state_flow', label: '🕸️ State Flow' },
        ],
        configureButtonTooltip: 'Configure Node & State Pins',
        buttonTitle:            '🕸️ My LangGraph Flows',
    },

};

/**
 * Merges backend-authoritative fields (simulationMode, polling, 
 * snapshotShape, sessionLabel) into the local CourseDomains object.
 * Called once by GlobalProvider on mount.
 */
export const mergeBackendDomains = (backendData) => {
  Object.entries(backendData).forEach(([domain, backendConfig]) => {
    if (CourseDomains[domain]) {
      Object.assign(CourseDomains[domain], backendConfig);
    }
  });
};

export const isHardwareDomain = (domain) => 
    CourseDomains[domain]?.canvasLayout === 'horizontal' &&
    (CourseDomains[domain]?.canvases?.length ?? 0) >= 3;

// Field names that should always render as auto-resizing, multi-line
// textareas wherever they appear in ComponentConfiguration's generic
// settings renderer — regardless of which component/domain they belong to.
export const MULTILINE_FIELDS = [
    'rawText',
    'messageText',
    'description',
    'promptTemplate',
    'contextTemplate',
    'systemPrompt',
    'humanTemplate',
];

export default CourseDomains;